import { IGSPCommonElement } from '../Interface/IGSPCommonElement';
import { ElementPathGenerateType } from '../Element/ElementPathGenerateType';

/**
 * 分级信息
 * @author wangjiegj<wangjiegj@inspur.com>
 */


/**
 * 分级信息
 */
export class GSPHirarchyInfo {

    /**
     * 分级码(前端仅存字段ID)
     */
    public PathElement: string;

    /**
     * 分级码步长(前端仅存字段ID)
     */
    public PathLength: number;

    /**
     * 级数(前端仅存字段ID)
     */
    public LayerElement: string;

    /**
     * 是否明细(前端仅存字段ID)
     */
    public IsDetailElement: string;

    /**
     * 父路径(前端仅存字段ID)
     */
    public ParentElement: string;

    /**
     * 分级信息生成时机
     */
    public PathGenerateType: ElementPathGenerateType;
}
